import { Chip, Typography } from "@mui/material";
import React from "react";

export const TableNoRowsCustomization = ({
  icon,
  text,
  subtext,
  children,
  minHeight = 150,
  iconBackground = 64,
}: {
  icon: React.JSX.Element;
  text: string;
  subtext?: string;
  children?: React.ReactNode;
  minHeight?: number;
  iconBackground?: number;
}) => {
  return (
    <div
      className="table-box-0"
      style={{
        minHeight: `${minHeight}px`,
      }}
    >
      <Chip
        icon={icon}
        style={{
          width: `${iconBackground}px`,
          height: `${iconBackground}px`,
          borderRadius: "1200px",
        }}
      ></Chip>
      <Typography variant="body1">{text}</Typography>
      {subtext && <Typography variant="subtitle2">{subtext}</Typography>}
      {children}
    </div>
  );
};
